// extracted by mini-css-extract-plugin
export default {"noModelsFoundText":"ModelsList_noModelsFoundText__3O9kM"};